module.exports = __webpack_public_path__ + "media/games-23.b11deb9a.mp4";